import { ApolloError, useQuery } from '@apollo/client'
import { GetManagerMeetingStepTargetsQuery, GetManagerMeetingStepTargetsQueryVariables, Country } from '../../../types'
import { GET_MANAGER_MEETING_STEP_TARGETS } from '../Queries'

export default (
  employeeId: number,
  meetingId: number,
  year: number,
  country: Country,
  withChanges = false,
  includeAllTargetBoni = true,
): { data: GetManagerMeetingStepTargetsQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<GetManagerMeetingStepTargetsQuery, GetManagerMeetingStepTargetsQueryVariables>(
    GET_MANAGER_MEETING_STEP_TARGETS,
    {
      variables: {
        employeeId: employeeId,
        meetingId: meetingId,
        year: year,
        country: country,
        withChanges: withChanges,
        includeAllTargetBoni: includeAllTargetBoni,
      },
      fetchPolicy: 'network-only',
    },
  )

  return { data, error, loading }
}
